// Mirrors web-backend/utils/tutors_roles.js — the underlying FlightSchoolAdmin.role
// enum (primary_admin/staff_admin/operations/instructor) isn't renamed, this just
// maps it onto the "Owner / Manager / Receptionist / Instructor" language and
// powers wherever a role is shown to a user. Every school always has exactly
// one Owner — FlightSchool.primaryAdmin is a required single reference.
export const ROLE_DISPLAY = {
  primary_admin: {
    label: "Owner",
    powers: "Full control — billing, staff, and all Tutors settings including marketplace, payouts, and rates. Every school has exactly one.",
  },
  staff_admin: {
    label: "Manager",
    powers: "Manages students, staff, and Tutors settings (marketplace, payouts, rates) — same Tutors access as the Owner.",
  },
  operations: {
    label: "Receptionist",
    powers: "Front-desk access — can view schedules and bookings, but can't change Tutors settings or approve instructor requests.",
  },
  instructor: {
    label: "Instructor",
    powers: "Manages their own tutoring profile and availability. Needs the school's approval to become visible to students outside the school.",
  },
};

export const getRoleDisplay = (role) => ROLE_DISPLAY[role] || { label: role || "Unknown", powers: "" };
